import React from "react";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faBolt, faSignOutAlt, faFlag } from "@fortawesome/free-solid-svg-icons";
import { Nav, Button, Navbar, Container } from '@themesberg/react-bootstrap';
import { Routes } from "../routes";

export default (props) => {
  const history = useHistory();

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user_profile");
    history.push(Routes.Signin.path);
  };

  return (
    <Navbar variant="light" expanded className="px-0 py-0" style={{ backgroundColor: '#F8F9FA', borderBottom: '1px solid #E9ECEF', minHeight: '46px' }}>
      <Container fluid className="px-3">
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="d-flex align-items-center">
            <Button
              variant="link"
              className="p-0 text-dark d-none d-md-inline-block"
              style={{ fontSize: '1.25rem', textDecoration: 'none' }}
              onClick={props.toggleSidebar}
            >
              <FontAwesomeIcon icon={faBars} />
            </Button>
          </div>

          {/* Right: Action Buttons */}
          <Nav className="align-items-center" style={{ gap: '8px' }}>
            {/* Red Logout Icon */}
            <Button
              size="sm"
              onClick={handleLogout}
              className="px-3 py-1"
              style={{
                backgroundColor: '#E74C3C',
                borderColor: '#E74C3C',
                color: '#FFFFFF',
                borderRadius: '4px',
                fontSize: '0.85rem',
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
              }}
            >
              <FontAwesomeIcon icon={faSignOutAlt} />
              <span className="small font-weight-bold">Déconnexion</span>
            </Button>
          </Nav>
        </div>
      </Container>
    </Navbar>
  );
};
